import { useAuthStore } from '@/stores/auth.store';
import { useTenantStore } from '@/stores/tenant.store';

export const NO_TENANT_QUERY_KEY = '__no_tenant__';

export function getActiveTenantId(): string | null {
  return useTenantStore.getState().tenantId ?? useAuthStore.getState().tenantId ?? null;
}

export function getActiveTenantQueryKey(): string {
  return getActiveTenantId() ?? NO_TENANT_QUERY_KEY;
}
